export default __webpack_public_path__ + "static/grynn-hosting-og-0c27da7488499735ae8d98b20c63350b.png";